/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PermissionList } from '../models/PermissionList';
import type { RolePermission } from '../models/RolePermission';
import type { UserRoles } from '../models/UserRoles';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PermissionApIsService {

    /**
     * API to get all user permissions
     * @returns PermissionList Success
     * @throws ApiError
     */
    public static permissionGetPermissionByRole(): CancelablePromise<Array<PermissionList>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permission',
            errors: {
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get permissions by role for create and edit
     * @param roleId
     * @returns RolePermission Success
     * @throws ApiError
     */
    public static permissionGetRoleBasedPermissions(
        roleId?: string,
    ): CancelablePromise<RolePermission> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permission/rolePermissions',
            query: {
                'roleId': roleId,
            },
            errors: {
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to create permissions for roles
     * @param requestBody
     * @returns RolePermission Success
     * @throws ApiError
     */
    public static permissionCreateRolePermissions(
        requestBody?: RolePermission,
    ): CancelablePromise<RolePermission> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/permission/rolePermissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get  user level Permission
     * @param userId
     * @returns RolePermission Success
     * @throws ApiError
     */
    public static permissionGetPermission(
        userId?: string,
    ): CancelablePromise<RolePermission> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permission/userLevelPermission',
            query: {
                'userId': userId,
            },
            errors: {
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get UserRoles List
     * @param searchInput
     * @returns UserRoles Success
     * @throws ApiError
     */
    public static permissionGetUserRoles(
        searchInput?: string,
    ): CancelablePromise<Array<UserRoles>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/permission/UserRoles',
            query: {
                'searchInput': searchInput,
            },
            errors: {
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to delete role
     * @param id
     * @returns string Success
     * @throws ApiError
     */
    public static permissionDeleteRole(
        id: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/permission/role/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

}
